import React, { useMemo, useState } from "react";
import BarraPrincipal from "../Modulos/BarraPrincipal";
import axios from "../utils/axiosConfig";
import { formattedGlobalDate } from "../utils/formattedDates";

const HEADERS = [
    { key: "id_movimiento", label: "ID", w: 90 },
    { key: "usuario", label: "Usuario", w: 140 },
    { key: "movimiento", label: "Movimiento", w: 120 },
    { key: "id_row", label: "Texto", w: 110 },
    { key: "hora", label: "Fecha", w: 170 },
    { key: "Causal", label: "Causal", w: 220 },
];

const MovimientoUsuario = () => {
    const [filters, setFilters] = useState({
        usuario: "",
        fecha: "",  // yyyy-mm-dd
        texto: "",  // opcional
    });

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");

    // ---- helpers sort ----
    const parseVal = (v) => {
        if (v == null) return null;
        const asNum = Number(v);
        if (!Number.isNaN(asNum) && String(v).trim() !== "") return asNum;
        const asTs = Date.parse(String(v).replace(" ", "T"));
        if (!Number.isNaN(asTs)) return asTs;
        return String(v).toLowerCase();
    };
    const cmp = (a, b) =>
        a === b ? 0 : a == null ? 1 : b == null ? -1 : a > b ? 1 : -1;

    const sortedRows = useMemo(() => {
        if (!sortBy) return rows;
        const dir = sortDirection === "asc" ? 1 : -1;
        return [...rows].sort(
            (r1, r2) => dir * cmp(parseVal(r1?.[sortBy]), parseVal(r2?.[sortBy]))
        );
    }, [rows, sortBy, sortDirection]);

    const handleSort = (key) => {
        if (sortBy === key) setSortDirection((d) => (d === "asc" ? "desc" : "asc"));
        else {
            setSortBy(key);
            setSortDirection("asc");
        }
    };

    const renderSortIcon = (key) =>
        sortBy === key ? (sortDirection === "asc" ? <span>↑</span> : <span>↓</span>) : null;

    // ---- acciones ----
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((f) => ({ ...f, [name]: value }));
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const { texto, usuario, fecha } = filters;
            const data = await getMovimientosUsuarios(texto, usuario, fecha);

            const mapped = (Array.isArray(data) ? data : data?.items || []).map((x) => ({
                id_movimiento: x.id_movimiento,
                usuario: x.usuario,
                movimiento: x.movimiento,
                id_row: x.id_row,
                hora: formattedGlobalDate(x.hora),
                Causal: x.Causal,
            }));

            setRows(mapped);
        } catch (err) {
            console.error(err);
            alert("Error cargando datos.");
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        setFilters({ usuario: "", texto: "", fecha: "" });
        setRows([]);
        setSortBy(null);
        setSortDirection("asc");
    };

    const getMovimientosUsuarios = async (texto, usuario, fecha) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SERVER}/operaciones2/getmovimientosusuarios`,
                JSON.stringify({ usuario, fecha, texto })
            );
            return res.data?.data?.recordset ?? [];
        } catch (error) {
            console.log("Error obteniendo movimientos:", error);
            return [];
        }
    };

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <div className="layout-page">
                    <BarraPrincipal />
                    <div className="content-wrapper">
                        <div className="container-fluid flex-grow-1 container-p-y">
                            {/* Título */}
                            <h4 className="mb-3 text-center">Movimiento Usuarios</h4>

                            {/* Filtros */}
                            <div className="card mb-2">
                                <div className="card-body py-3">
                                    <div className="row align-items-end gx-filtros">
                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label className="form-label mb-1">Texto</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="texto"
                                                value={filters.texto}
                                                onChange={handleChange}
                                                placeholder="ABC123"
                                                style={{ boxSizing: "border-box", height: "40px" }}
                                            />
                                        </div>

                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label className="form-label mb-1">Usuario</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="usuario"
                                                value={filters.usuario}
                                                onChange={handleChange}
                                                placeholder="usuario"
                                                style={{ boxSizing: "border-box", height: "40px" }}
                                            />
                                        </div>

                                        <div className="col-12 col-sm-6 col-lg-2">
                                            <label className="form-label mb-1">Fecha</label>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name="fecha"
                                                value={filters.fecha}
                                                onChange={handleChange}
                                                style={{ boxSizing: "border-box", height: "40px" }}
                                            />
                                        </div>

                                        <div className="col-12 col-lg-2">
                                            <div className="d-grid d-lg-flex gap-2 justify-content-lg-end">
                                                <button
                                                    className="btn btn-primary btn-sm w-100 w-lg-auto"
                                                    onClick={handleSearch}
                                                    disabled={loading}
                                                    type="button"
                                                    style={{ boxSizing: "border-box", height: "40px" }}
                                                >
                                                    {loading ? "Buscando..." : "Buscar"}
                                                </button>
                                                <button
                                                    className="btn btn-outline-secondary btn-sm w-100 w-lg-auto"
                                                    onClick={handleClear}
                                                    type="button"
                                                    style={{ boxSizing: "border-box"}}
                                                >
                                                    Limpiar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* styled-jsx: gutters de filtros */}
                                <style jsx>{`
                                .gx-filtros {
                                    --bs-gutter-x: 1.25rem;
                                    --bs-gutter-y: 0.75rem;
                                }
                                @media (min-width: 992px) {
                                    .gx-filtros {
                                    --bs-gutter-x: 2rem;
                                    }
                                }
                                @media (min-width: 992px) {
                                    .w-lg-auto {
                                    width: auto !important;
                                    }
                                }
                                `}</style>
                            </div>

                            {/* LISTA RESPONSIVE */}
                            {/* Cards en pantallas pequeñas */}
                            <div className="d-lg-none">
                                {loading && (
                                    <div className="card mb-3">
                                        <div className="card-body text-center text-muted">Cargando…</div>
                                    </div>
                                )}

                                {!loading && sortedRows.length === 0 && (
                                    <div className="card mb-3">
                                        <div className="card-body text-center text-muted">Sin resultados.</div>
                                    </div>
                                )}

                                <div className="cards-grid">
                                    {sortedRows.map((item) => (
                                        <div className="card" key={item.id_movimiento}>
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                    <div>
                                                        <div className="fw-semibold">{item.usuario || "(sin usuario)"}</div>
                                                        <div className="text-muted small">{item.hora || "-"}</div>
                                                    </div>
                                                    <span className="badge bg-secondary">ID {item.id_movimiento}</span>
                                                </div>

                                                <div className="row g-2 small">
                                                    <div className="col-6">
                                                        <div className="text-muted">Movimiento</div>
                                                        <div className="fw-medium">{item.movimiento || "-"}</div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="text-muted">Texto</div>
                                                        <div className="fw-medium">{item.id_row || "-"}</div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="text-muted">Causal</div>
                                                        <div className="fw-medium">{item.Causal || "-"}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <style jsx>{`
                  .cards-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 12px;
                  }
                  @media (min-width: 576px) {
                    .cards-grid {
                      grid-template-columns: 1fr 1fr;
                    }
                  }
                `}</style>
                            </div>

                            {/* Tabla en pantallas grandes */}
                            <div className="card cardContainerTrafico d-none d-lg-block">
                                <div
                                    className="table-responsive text-nowrap"
                                    style={{
                                        height: `calc(100vh - 240px)`,
                                        overflowY: "auto",
                                        overflowX: "auto",
                                        position: "relative",
                                    }}
                                >
                                    <table className="table table-hover table-sm mb-0" id="tablaTRAF">
                                        <thead className="FondoHeaderTabla2">
                                            <tr>
                                                {HEADERS.map((h) => (
                                                    <th
                                                        key={h.key}
                                                        style={{
                                                            color: "#ffffff",
                                                            width: h.w || "auto",
                                                            cursor: "pointer",
                                                            whiteSpace: "nowrap",
                                                            height: 40,
                                                            textAlign: "center",
                                                            alignContent: "center",
                                                        }}
                                                        onClick={() => handleSort(h.key)}
                                                    >
                                                        {h.label} {renderSortIcon(h.key)}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>

                                        <tbody className="table-border-bottom-0" id="tabladata">
                                            {sortedRows.map((item, idx) => (
                                                <tr key={item.id_movimiento ?? idx}>
                                                    <td>{item.id_movimiento}</td>
                                                    <td>{item.usuario}</td>
                                                    <td>{item.movimiento}</td>
                                                    <td>{item.id_row}</td>
                                                    <td style={{ whiteSpace: "nowrap" }}>{item.hora}</td>
                                                    <td>{item.Causal}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Overlay de "sin datos / cargando" ocupando 100% del contenedor */}
                                    {sortedRows.length === 0 && (
                                        <div
                                            className="d-flex align-items-center justify-content-center text-muted"
                                            style={{
                                                position: "absolute",
                                                top: 40, // altura del thead
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                padding: "0 16px",
                                                pointerEvents: "none",

                                            }}
                                        >
                                            {loading ? "Cargando..." : "Sin resultados."}
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MovimientoUsuario;
